<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="单位调查表录入" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                            <FGCollapsiblePanel title="单位调查表录入">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="基本情况表编号">
                                            <a-input ref="jbqkbbh" v-model="editData.jbqkbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="调查日期" required>
                                            <a-date-picker
                                                ref="njrq"
                                                style="width:100%"
                                                valueFormat="YYYY-MM-DD"
                                                v-model="editData.njrq"
                                                placeholder="调查日期"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="调查年份" required>
                                            <FGDictSelect ref="njnf" dictNo="1111" v-model="editData.njnf" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位编号">
                                            <a-input ref="dwbh" v-model="editData.dwbh" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="单位名称">
                                            <a-input ref="dwmc" v-model="editData.dwmc" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位类型">
                                            <FGDictSelectCN ref="dwlx" dictNo="DW100101" v-model="editData.dwlx" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="单位类别" required>
                                            <FGDictSelectCN ref="dwlb" dictNo="DW100102" v-model="editData.dwlb" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="资信等级" required>
                                            <FGDictSelectCN ref="zxdj" dictNo="ZX100102" v-model="editData.zxdj" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="区域名称" required>
                                            <a-input-search ref="qymc" @search="isShow_qyxx = true" v-model="editData.qymc" />
                                            <FGDataSelect
                                                :isShow.sync="isShow_qyxx"
                                                selectNo="JC100101T"
                                                @saveselect="saveEvent_qyxx(arguments)"
                                            ></FGDataSelect>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册地址" required>
                                            <a-input ref="zcdz" v-model="editData.zcdz" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="办公地址" required>
                                            <a-input ref="bgdz" v-model="editData.bgdz" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="邮政编码" required>
                                            <a-input ref="yzbm" v-model="editData.yzbm" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="行业分类" required>
                                            <a-input-search ref="hyfl" @search="isShow_zyxx = true" v-model="editData.hyfl" />
                                            <FGDataSelect :isShow.sync="isShow_zyxx" selectNo="JC1002" @saveselect="saveEvent_zyxx(arguments)"></FGDataSelect>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册资金（万元）" required>
                                            <a-input-number ref="zczj" v-model="editData.zczj" style="width:100%" :min="0" :precision="2" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="法人代表" required>
                                            <a-input ref="frdb" v-model="editData.frdb" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="法人固定电话" required>
                                            <a-input ref="frgddh" v-model="editData.frgddh" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="法人移动电话" required>
                                            <a-input ref="fryddh" v-model="editData.fryddh" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系人" required>
                                            <a-input ref="lxr" v-model="editData.lxr" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="固定电话" required>
                                            <a-input ref="gddh" v-model="editData.gddh" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="移动电话" required>
                                            <a-input ref="yddh" v-model="editData.yddh" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>

                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="传真">
                                            <a-input ref="cz" v-model="editData.cz" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="电子邮箱">
                                            <a-input ref="dzyx" v-model="editData.dzyx" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="网址">
                                            <a-input ref="wz" v-model="editData.wz" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位性质">
                                            <a-input ref="dwxz" v-model="editData.dwxz" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="职工总人数" required>
                                            <a-input-number ref="zgzrs" v-model="editData.zgzrs" :min="0" :precision="0" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="专业技术人员数" required>
                                            <a-input-number ref="zyjsrs" v-model="editData.zyjsrs" :min="0" :precision="0" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="专职从事工程咨询人数" required>
                                            <a-input-number ref="zzcszxrs" v-model="editData.zzcszxrs" :min="0" :precision="0" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册咨询师人数" required>
                                            <a-input-number ref="zczxsrs" v-model="editData.zczxsrs" :min="0" :precision="0" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="高级职称人数" required>
                                            <a-input-number ref="gjzcrs" v-model="editData.gjzcrs" :min="0" :precision="0" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="中级职称人数" required>
                                            <a-input-number ref="zjzcrs" v-model="editData.zjzcrs" :min="0" :precision="0" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="初级职称人数" required>
                                            <a-input-number ref="cjzcrs" v-model="editData.cjzcrs" :min="0" :precision="0" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="博士人数" required>
                                            <a-input-number ref="bsrs" v-model="editData.bsrs" :min="0" :precision="0" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="硕士人数" required>
                                            <a-input-number ref="ssrs" v-model="editData.ssrs" :min="0" :precision="0" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="本科人数" required>
                                            <a-input-number ref="bkrs" v-model="editData.bkrs" :min="0" :precision="0" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="会费缴纳标准(元/年)" required>
                                            <a-input-number
                                                ref="hfjnbz"
                                                v-model="editData.hfjnbz"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="办公面积（平方）" required>
                                            <a-input-number
                                                ref="bgmj"
                                                v-model="editData.bgmj"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="其中自有面积(平方)" required>
                                            <a-input-number
                                                ref="zymj"
                                                v-model="editData.zymj"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="计算机台数">
                                            <a-input-number ref="jsjts" v-model="editData.jsjts" :min="0" :precision="0" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="质量体系认证">
                                            <a-input ref="zltxrz" v-model="editData.zltxrz" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="认证日期">
                                            <a-date-picker ref="rzrq" v-model="editData.rzrq" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="认证机构">
                                            <a-input ref="rzjg" v-model="editData.rzjg" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="单位简介" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                                            <a-textarea ref="dwjj" :rows="3" v-model="editData.dwjj" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="前期咨询收入(万元)" required>
                                            <a-input-number
                                                ref="qqzxsr"
                                                v-model="editData.qqzxsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                @change="onChange"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="工程设计收入(万元)" required>
                                            <a-input-number
                                                ref="gcsjsr"
                                                v-model="editData.gcsjsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                @change="onChange"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="工程监理收入(万元)" required>
                                            <a-input-number
                                                ref="gcjlsr"
                                                v-model="editData.gcjlsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                @change="onChange"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="招标代理收入(万元)" required>
                                            <a-input-number
                                                ref="zbdlsr"
                                                v-model="editData.zbdlsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                @change="onChange"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="项目管理收入(万元)" required>
                                            <a-input-number
                                                ref="xmglsr"
                                                v-model="editData.xmglsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                @change="onChange"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="其他收入(万元)" required>
                                            <a-input-number
                                                ref="qtsr"
                                                v-model="editData.qtsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                @change="onChange"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="收入合计(万元)" required>
                                            <a-input-number
                                                ref="hjsr"
                                                v-model="editData.hjsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="年上缴税金(万元)" required>
                                            <a-input-number
                                                ref="nsjsj"
                                                v-model="editData.nsjsj"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="税后利润(万元)" required>
                                            <a-input-number
                                                ref="shlr"
                                                v-model="editData.shlr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="年底资产总额(万元)" required>
                                            <a-input-number
                                                ref="ndzcze"
                                                v-model="editData.ndzcze"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="省外咨询项目数(个)" required>
                                            <a-input-number ref="swzxxms" v-model="editData.swzxxms" :min="0" :precision="0" :max="65535" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="省外收入(万元)" required>
                                            <a-input-number
                                                ref="swsr"
                                                v-model="editData.swsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="省外咨询固定资产投资额(万元)" required>
                                            <a-input-number
                                                ref="swzxgdzctze"
                                                v-model="editData.swzxgdzctze"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="境外咨询项目数(个)" required>
                                            <a-input-number ref="jwzxxms" v-model="editData.jwzxxms" style="width:100%" :min="0" :precision="0" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="外汇收入(万美元)" required>
                                            <a-input-number
                                                ref="whsr"
                                                v-model="editData.whsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="境外咨询固定资产投资额(万元)" required>
                                            <a-input-number
                                                ref="jwzxgdzctze"
                                                v-model="editData.jwzxgdzctze"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="奖励和表彰" required>
                                            <a-input ref="jlbz" v-model="editData.jlbz" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="工商营业执照" required>
                                            <a-input ref="gsyyzz" v-model="editData.gsyyzz" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="设计证书" required>
                                            <a-input ref="sjzs" v-model="editData.sjzs" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="监理证书" required>
                                            <a-input ref="jlzs" v-model="editData.jlzs" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrr" v-model="editData.lrr" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="录入时间">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单据状态">
                                            <a-input ref="djzt" v-model="editData.djzt" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="年检亿元项目表明细">
                                <vxe-toolbar size="mini">
                                    <template v-slot:tools>
                                        <a-button type="primary" :loading="saving || loading" @click="insertYyxmItem" style="margin-right:10px">新增</a-button>
                                    </template>
                                </vxe-toolbar>
                                <vxe-table
                                    ref="yyxmtable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :data="yyxmTableData"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable></vxe-table-column>
                                    <vxe-table-column field="xmmc" title="项目名称" align="center"></vxe-table-column>
                                    <vxe-table-column field="zybh" title="专业编号" align="center"></vxe-table-column>
                                    <vxe-table-column field="zymc" title="专业名称" align="center"></vxe-table-column>
                                    <vxe-table-column field="zxfwfw" title="咨询服务范围" align="center"></vxe-table-column>
                                    <vxe-table-column field="jsgm" title="建设规模" align="center"></vxe-table-column>
                                    <vxe-table-column field="gdzctze" title="固定资产投资额" align="center"></vxe-table-column>
                                    <vxe-table-column field="wtdwmc" title="委托单位名称" align="center"></vxe-table-column>
                                    <vxe-table-column field="wtdwlxr" title="委托单位联系人" align="center"></vxe-table-column>
                                    <vxe-table-column field="wtdwdh" title="委托单位电话" align="center"></vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" align="center" width="180px"></vxe-table-column>
                                    <vxe-table-column title="操作" width="100" align="center">
                                        <template v-slot="scope">
                                            <span class="btn_edit" @click="removeYyxmItem(scope.row)">删除</span>
                                            <span class="btn_edit" @click="editYyxmItem(scope.row)">编辑</span>
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="年检前期项目表明细">
                                <vxe-toolbar size="mini">
                                    <template v-slot:tools>
                                        <a-button type="primary" :loading="saving || loading" @click="insertQqxmItem" style="margin-right:10px">新增</a-button>
                                    </template>
                                </vxe-toolbar>
                                <vxe-table
                                    ref="qqxmtable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :data="qqxmTableData"
                                    :edit-config="{
                                        trigger: 'click',
                                        mode: 'row',
                                        showStatus: true,
                                        showIcon: false
                                    }"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable></vxe-table-column>
                                    <vxe-table-column field="zybh" title="专业编号" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zymc" title="专业名称" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_gh" title="咨询项目数|规划" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="zxxms_xmjys" title="咨询项目数|项目建议书" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_kybg" title="咨询项目数|可研报告" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_xmsqbg" title="咨询项目数|项目申请报告" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_zjsqbg" title="咨询项目数|资金申请报告" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_pg" title="咨询项目数|评估" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_jnps" title="咨询项目数|节能评审" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_gcxmgl" title="咨询项目数|工程项目管理" align="center" width="100"></vxe-table-column>
                                    <vxe-table-column field="gdzctze" title="固定资产投资额" align="center" width="100"></vxe-table-column>
                                    <vxe-table-column field="pgzxhze" title="评估咨询项目|核增额" align="center" width="100"></vxe-table-column>
                                    <vxe-table-column field="pgzxhje" title="评估咨询项目|核减额" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column title="操作" width="100" align="center">
                                        <template v-slot="scope">
                                            <span class="btn_edit" @click="removeQqxmItem(scope.row)">删除</span>
                                            <span class="btn_edit" @click="editQqxmItem(scope.row)">编辑</span>
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>

                            <FGCollapsiblePanel title="年检客户反应表明细">
                                <vxe-toolbar size="mini">
                                    <template v-slot:tools>
                                        <a-button type="primary" :loading="saving || loading" @click="insertKhfyItem" style="margin-right:10px">新增</a-button>
                                    </template>
                                </vxe-toolbar>
                                <vxe-table
                                    ref="khfytable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :data="khfyTableData"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable> </vxe-table-column>
                                    <vxe-table-column field="zybh" title="专业编号" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="zymc" title="专业名称" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="wcsl" title="完成数量" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pjsl" title="评价数量" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pjl" title="评价率(%)" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pjjg_yxxms" title="评价结果|优秀" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pjjg_lhxms" title="评价结果|良好" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pjjg_hgxms" title="评价结果|合格" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pjjg_bhgxms" title="评价结果|不合格" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="khfy_fcmyxms" title="咨询项目客户反应|非常满意项目数" align="center" width="100px">
                                    </vxe-table-column>
                                    <vxe-table-column field="khfy_bjmyxms" title="咨询项目客户反应|比较满意项目数" align="center" width="100px">
                                    </vxe-table-column>
                                    <vxe-table-column field="khfy_fyybxms" title="咨询项目客户反应|反应一般项目数" align="center" width="100px">
                                    </vxe-table-column>
                                    <vxe-table-column field="khfy_fyjcxms" title="咨询项目客户反应|反应较差项目数" align="center" width="100px">
                                    </vxe-table-column>
                                    <vxe-table-column field="zxhtlyl" title="咨询合同履约率(%)" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" align="center" width="180px"> </vxe-table-column>
                                    <vxe-table-column title="操作" width="100" align="center">
                                        <template v-slot="scope">
                                            <span class="btn_edit" @click="removeKhfyItem(scope.row)">删除</span>
                                            <span class="btn_edit" @click="editKhfyItem(scope.row)">编辑</span>
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="年检咨询工程师表明细">
                                <vxe-toolbar size="mini">
                                    <template v-slot:tools>
                                        <a-button type="primary" :loading="saving || loading" @click="insertZxgcsItem" style="margin-right:10px">新增</a-button>
                                    </template>
                                </vxe-toolbar>
                                <vxe-table
                                    ref="zxgcstable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :data="zxgcsTableData"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable></vxe-table-column>
                                    <vxe-table-column field="xm" title="姓名" align="center"></vxe-table-column>
                                    <vxe-table-column field="xb" title="性别" align="center"></vxe-table-column>
                                    <vxe-table-column field="zjlx" title="证件类型" align="center"></vxe-table-column>
                                    <vxe-table-column field="zjhm" title="证件号码" align="center"></vxe-table-column>
                                    <vxe-table-column field="nl" title="年龄" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zc" title="职称" align="center"></vxe-table-column>
                                    <vxe-table-column field="zczy" title="职称专业" align="center"></vxe-table-column>
                                    <vxe-table-column field="xl" title="学历" align="center"></vxe-table-column>
                                    <vxe-table-column field="xw" title="学位" align="center"></vxe-table-column>
                                    <vxe-table-column field="sxzy" title="所学专业" align="center"></vxe-table-column>
                                    <vxe-table-column field="zczbh" title="注册咨询工程师(投资)|注册证编号" align="center"></vxe-table-column>
                                    <vxe-table-column field="zzy" title="注册咨询工程师(投资)|主专业 " align="center"></vxe-table-column>
                                    <vxe-table-column field="fzy" title="注册咨询工程师(投资)|辅专业" align="center"></vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" align="center" width="180px"></vxe-table-column>
                                    <vxe-table-column title="操作" width="100" align="center">
                                        <template v-slot="scope">
                                            <span class="btn_edit" @click="removeZxgcsItem(scope.row)">删除</span>
                                            <span class="btn_edit" @click="editZxgcsItem(scope.row)">编辑</span>
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="年检自查结果表明细">
                                <vxe-toolbar size="mini">
                                    <template v-slot:tools>
                                        <a-button type="primary" :loading="saving || loading" @click="insertZcjgItem" style="margin-right:10px">新增</a-button>
                                    </template>
                                </vxe-toolbar>
                                <vxe-table
                                    ref="zcjgtable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :data="zcjgTableData"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable> </vxe-table-column>
                                    <vxe-table-column field="zcnr" title="自查内容" align="center"> </vxe-table-column>
                                    <vxe-table-column field="zcyj" title="自查意见" align="center"> </vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" align="center" width="180px"> </vxe-table-column>
                                    <vxe-table-column title="操作" width="100" align="center">
                                        <template v-slot="scope">
                                            <span class="btn_edit" @click="removeZcjgItem(scope.row)">删除</span>
                                            <span class="btn_edit" @click="editZcjgItem(scope.row)">编辑</span>
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>

                            <!-- 操作日志 -->
                            <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                        </a-form>
                    </a-spin>
                    <!-- 流程跟踪组件 -->
                    <!-- <ActiveHistoryProcess ref="activitishow" :histProcProps="historyProcessProps"></ActiveHistoryProcess> -->
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUpload :isnew="editData.isnew" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
        <YyxmAdd
            :showEdit.sync="yyxmProps.showEdit"
            :dataId="yyxmProps.dataId"
            :yyxmbid="yyxmProps.yyxmbid"
            :xh="yyxmProps.xh"
            @dataUpdated="loadYyxmTableData2"
        ></YyxmAdd>
        <QqxmAdd
            :showEdit.sync="qqxmProps.showEdit"
            :dataId="qqxmProps.dataId"
            :qqxmbid="qqxmProps.qqxmbid"
            :xh="qqxmProps.xh"
            @dataUpdated="loadQqxmTableData2"
        ></QqxmAdd>
        <KhfyAdd
            :showEdit.sync="khfyProps.showEdit"
            :dataId="khfyProps.dataId"
            :khfybid="khfyProps.khfybid"
            :xh="khfyProps.xh"
            @dataUpdated="loadKhfyTableData2"
        ></KhfyAdd>
        <ZxgcsAdd
            :showEdit.sync="zxgcsProps.showEdit"
            :dataId="zxgcsProps.dataId"
            :zxgcsbid="zxgcsProps.zxgcsbid"
            :xh="zxgcsProps.xh"
            @dataUpdated="loadZxgcsTableData2"
        ></ZxgcsAdd>
        <ZcjgAdd
            :showEdit.sync="zcjgProps.showEdit"
            :dataId="zcjgProps.dataId"
            :zcjgbid="zcjgProps.zcjgbid"
            :xh="zcjgProps.xh"
            @dataUpdated="loadZcjgTableData2"
        ></ZcjgAdd>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
import YyxmAdd from "../components/YyxmAdd.vue";
import QqxmAdd from "../components/QqxmAdd.vue";
import KhfyAdd from "../components/KhfyAdd.vue";
import ZxgcsAdd from "../components/ZxgcsAdd.vue";
import ZcjgAdd from "../components/ZcjgAdd.vue";
export default {
    name: "DwdclrEdit",
    props: ["showEdit", "dataId"],
    components: { YyxmAdd, QqxmAdd, KhfyAdd, ZxgcsAdd, ZcjgAdd },
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            dwxxData: {},
            editData: {},
            editDataLoading: false,
            yyxmTableData: [],
            yyxmTableDataLoading: false,
            qqxmTableData: [],
            qqxmTableDataLoading: false,
            khfyTableData: [],
            khfyTableDataLoading: false,
            zxgcsTableData: [],
            zxgcsTableDataLoading: false,
            zcjgTableData: [],
            zcjgTableDataLoading: false,
            isShow_qyxx: false,
            isShow_zyxx: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            },
            yyxmProps: {
                xh: 1,
                showEdit: false,
                dataId: null,
                yyxmbid: null
            },
            qqxmProps: {
                xh: 1,
                showEdit: false,
                dataId: null,
                qqxmbid: null
            },
            khfyProps: {
                xh: 1,
                showEdit: false,
                dataId: null,
                khfybid: null
            },
            zxgcsProps: {
                xh: 1,
                showEdit: false,
                dataId: null,
                zxgcsbid: null
            },
            zcjgProps: {
                xh: 1,
                showEdit: false,
                dataId: null,
                zcjgbid: null
            },
            // 流程跟踪参数
            historyProcessProps: {
                visible: false,
                billid: "",
                instanceId: "",
                processKey: "DWDCBLRSH"
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
                this.operLogProps.visible = newVal;
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return (
                this.editDataLoading ||
                this.yyxmTableDataLoading ||
                this.qqxmTableDataLoading ||
                this.khfyTableDataLoading ||
                this.zxgcsTableDataLoading ||
                this.zcjgTableDataLoading
            );
        },
        attachCfg() {
            return {
                fktable: "NJ_JBQKB",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "DWDC01"
            };
        }
    },
    activated() {
        if (!this.editDataId) {
            this.$FG_helper.handleNewBillCode("JBQKBBH").then((val) => {
                // 新增，设置默认值
                this.editData = {
                    id: this.$FG_util.uuid(),
                    isnew: true,
                    djzt: "制定",
                    jbqkbbh: val,
                    djlxid: "JBQKB",
                    yhid: this.getUserInfo.id,
                    lrr: this.getUserInfo.personnel_name,
                    lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                    bmid: this.getUserInfo.org_id,
                    ryid: this.getUserInfo.personnel_id,
                    //根据当前用户单位信息设置默认值
                    dwid: this.getUserInfo.companyInfo.id,
                    dwbh: this.getUserInfo.companyInfo.dwbh,
                    dwmc: this.getUserInfo.companyInfo.dwmc,
                    dwlx: this.getUserInfo.companyInfo.dwlx,
                    dwlb: this.getUserInfo.companyInfo.dwlb,
                    zxdj: this.getUserInfo.companyInfo.zxdj,
                    qyid: this.getUserInfo.companyInfo.qyid,
                    qymc: this.getUserInfo.companyInfo.qymc,
                    zcdz: this.getUserInfo.companyInfo.zcdz,
                    bgdz: this.getUserInfo.companyInfo.bgdz,
                    yzbm: this.getUserInfo.companyInfo.yzbm,
                    hyfl: this.getUserInfo.companyInfo.hyfl,
                    zczj: this.getUserInfo.companyInfo.zczj,
                    frdb: this.getUserInfo.companyInfo.frdb,
                    frgddh: this.getUserInfo.companyInfo.frgddh,
                    fryddh: this.getUserInfo.companyInfo.fryddh,
                    lxr: this.getUserInfo.companyInfo.lxr,
                    gddh: this.getUserInfo.companyInfo.gddh,
                    yddh: this.getUserInfo.companyInfo.yddh,
                    cz: this.getUserInfo.companyInfo.cz,
                    dzyx: this.getUserInfo.companyInfo.dzyx,
                    wz: this.getUserInfo.companyInfo.wz,
                    dwxz: this.getUserInfo.companyInfo.dwxz,
                    zgzrs: this.getUserInfo.companyInfo.zgzrs,
                    zyjsrys: this.getUserInfo.companyInfo.zyjsrys,
                    zzcszxrs: this.getUserInfo.companyInfo.zzcszxrs,
                    zczxsrs: this.getUserInfo.companyInfo.zczxsrs,
                    gjzcrs: this.getUserInfo.companyInfo.gjzcrs,
                    zjzcrs: this.getUserInfo.companyInfo.zjzcrs,
                    cjzcrs: this.getUserInfo.companyInfo.cjzcrs,
                    bsrs: this.getUserInfo.companyInfo.bsrs,
                    ssrs: this.getUserInfo.companyInfo.ssrs,
                    bkrs: this.getUserInfo.companyInfo.bkrs,
                    hfjnbz: this.getUserInfo.companyInfo.hfjnbz,
                    bgmj: this.getUserInfo.companyInfo.bgmj,
                    zymj: this.getUserInfo.companyInfo.zymj,
                    jsjts: this.getUserInfo.companyInfo.jsjts,
                    zltxrz: this.getUserInfo.companyInfo.zltxrz,
                    rzrq: this.getUserInfo.companyInfo.rzrq,
                    rzjg: this.getUserInfo.companyInfo.rzjg,
                    dwjj: this.getUserInfo.companyInfo.dwjj,
                    //收入默认值
                    qqzxsr: 0,
                    gcsjsr: 0,
                    gcjlsr: 0,
                    zbdlsr: 0,
                    xmglsr: 0,
                    qtsr: 0
                };
                this.yyxmTableData = [];
                this.qqxmTableData = [];
                this.khfyTableData = [];
                this.zxgcsTableData = [];
                this.zcjgTableData = [];
                this.addZxgcsMx();
                this.addZcjgMx();
                this.loadZxgcsTableData();
                this.loadZcjgTableData();
                this.attachCfg.fkvalue = this.editData.id;
            });
        } else {
            // 修改，加载数据
            this.loadData();
            this.loadYyxmTableData();
            this.loadQqxmTableData();
            this.loadKhfyTableData();
            this.loadZxgcsTableData();
            this.loadZcjgTableData();
        }
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.njnf.focus();
        });
    },
    methods: {
        onChange() {
            this.editData.hjsr =
                parseFloat(this.editData.qqzxsr) +
                parseFloat(this.editData.gcsjsr) +
                parseFloat(this.editData.gcjlsr) +
                parseFloat(this.editData.zbdlsr) +
                parseFloat(this.editData.xmglsr) +
                parseFloat(this.editData.qtsr);
        },
        saveEvent_qyxx(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.qyid = val[0][0].ID;
                this.editData.qybh = val[0][0].QYBH;
                this.editData.qymc = val[0][0].QYMC;
            }
        },
        saveEvent_zyxx(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.hyfl = val[0][0].ZYMC;
            }
        },
        addZxgcsMx() {
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/addZxgcsMx",
                    {
                        id: this.editData.id,
                        dwid: this.getUserInfo.companyInfo.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                    } else {
                        this.$refs.njnf.focus();
                    }
                });
        },
        addZcjgMx() {
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/addZcjgMx",
                    {
                        id: this.editData.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                    } else {
                        this.$refs.njnf.focus();
                    }
                });
        },

        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.initOperLog();
                            this.initWorkFlow();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        loadYyxmTableData() {
            this.yyxmTableData = [];
            this.yyxmTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listYyxmMx",
                    {
                        yyxmbid: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.yyxmTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.yyxmTableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        loadYyxmTableData2() {
            this.yyxmTableData = [];
            this.yyxmTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listYyxmMx",
                    {
                        yyxmbid: this.editData.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.yyxmTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.yyxmTableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 新增亿元项目明细
        insertYyxmItem() {
            // 设置编辑记录
            this.yyxmProps.dataId = null;
            this.yyxmProps.yyxmbid = this.editData.id;
            this.yyxmProps.xh = this.$refs.yyxmtable.getTableData().tableData.length + 1;
            // 显示新增窗口
            this.yyxmProps.showEdit = true;
        },
        // 新增亿元项目明细
        editYyxmItem(row) {
            // 设置编辑记录
            this.yyxmProps.dataId = row.id;
            this.yyxmProps.yyxmbid = this.editData.id;
            // 显示编辑窗口
            this.yyxmProps.showEdit = true;
        },
        // 删除亿元项目明细
        removeYyxmItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.yyxmtable.remove(row);
                    } else {
                        this.yyxmTableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/dwdcgl/dwdc/deleteYyxm", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.yyxmTableDataLoading = false;
                                if (success) {
                                    this.loadYyxmTableData();
                                }
                            });
                    }
                }
            });
        },
        loadQqxmTableData() {
            this.qqxmTableData = [];
            this.qqxmTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listQqxmMx",
                    {
                        qqxmbid: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.qqxmTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.qqxmTableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        loadQqxmTableData2() {
            this.qqxmTableData = [];
            this.qqxmTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listQqxmMx",
                    {
                        qqxmbid: this.editData.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.qqxmTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.qqxmTableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 年检前期项目表明细
        insertQqxmItem() {
            // 设置编辑记录
            this.qqxmProps.dataId = null;
            this.qqxmProps.qqxmbid = this.editData.id;
            this.qqxmProps.xh = this.$refs.qqxmtable.getTableData().tableData.length + 1;
            // 显示编辑窗口
            this.qqxmProps.showEdit = true;
        },
        editQqxmItem(row) {
            // 设置编辑记录
            this.qqxmProps.dataId = row.id;
            this.qqxmProps.qqxmbid = this.editData.id;
            // 显示新增窗口
            this.qqxmProps.showEdit = true;
        },
        // 删除年检前期项目表明细
        removeQqxmItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.qqxmtable.remove(row);
                    } else {
                        this.qqxmTableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/dwdcgl/dwdc/deleteQqxm", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.qqxmTableDataLoading = false;
                                if (success) {
                                    this.loadQqxmTableData();
                                }
                            });
                    }
                }
            });
        },
        loadKhfyTableData() {
            this.khfyTableData = [];
            this.khfyTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listKhfyMx",
                    {
                        khfybid: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.khfyTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.khfyTableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        loadKhfyTableData2() {
            this.khfyTableData = [];
            this.khfyTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listKhfyMx",
                    {
                        khfybid: this.editData.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.khfyTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.khfyTableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 新增年检客户反应表明细
        insertKhfyItem() {
            // 设置编辑记录
            this.khfyProps.dataId = null;
            this.khfyProps.khfybid = this.editData.id;
            this.khfyProps.xh = this.$refs.khfytable.getTableData().tableData.length + 1;
            // 显示编辑窗口
            this.khfyProps.showEdit = true;
        },
        editKhfyItem(row) {
            // 设置编辑记录
            this.khfyProps.dataId = row.id;
            this.khfyProps.khfybid = this.editData.id;
            // 显示新增窗口
            this.khfyProps.showEdit = true;
        },
        // 删除年检客户反应表明细
        removeKhfyItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.khfytable.remove(row);
                    } else {
                        this.khfyTableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/dwdcgl/dwdc/deleteKhfy", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.khfyTableDataLoading = false;
                                if (success) {
                                    this.loadKhfyTableData();
                                }
                            });
                    }
                }
            });
        },
        loadZxgcsTableData() {
            this.zxgcsTableData = [];
            this.zxgcsTableDataLoading = true;

            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listZxgcsMx",
                    {
                        zxgcsbid: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.zxgcsTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.zxgcsTableData = data.data;
                            this.zxgcsProps.xh = data.data.length + 1;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        loadZxgcsTableData2() {
            this.zxgcsTableData = [];
            this.zxgcsTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listZxgcsMx",
                    {
                        zxgcsbid: this.editData.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.zxgcsTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.zxgcsTableData = data.data;
                            this.zxgcsProps.xh = data.data.length + 1;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 新增咨询工程师表明细
        insertZxgcsItem() {
            this.loadZxgcsTableData();
            // 设置编辑记录
            this.zxgcsProps.dataId = null;
            this.zxgcsProps.zxgcsbid = this.editData.id;
            //this.zxgcsProps.xh = this.$refs.zxgcstable.getTableData().tableData.length + 1;
            // 显示编辑窗口
            this.zxgcsProps.showEdit = true;
        },
        editZxgcsItem(row) {
            // 设置编辑记录
            this.zxgcsProps.dataId = row.id;
            this.zxgcsProps.zxgcsbid = this.editData.id;
            // 显示新增窗口
            this.zxgcsProps.showEdit = true;
        },
        // 删除咨询工程师表明细
        removeZxgcsItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.zxgcstable.remove(row);
                    } else {
                        this.zxgcsTableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/dwdcgl/dwdc/deleteZxgcs", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.zxgcsTableDataLoading = false;
                                if (success) {
                                    this.loadZxgcsTableData();
                                }
                            });
                    }
                }
            });
        },
        loadZcjgTableData() {
            this.zcjgTableData = [];
            this.zcjgTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listZcjgMx",
                    {
                        zcjgbid: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.zcjgTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.zcjgTableData = data.data;
                            this.zcjgProps.xh = data.data.length + 1;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        loadZcjgTableData2() {
            this.zcjgTableData = [];
            this.zcjgTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listZcjgMx",
                    {
                        zcjgbid: this.editData.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.zcjgTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.zcjgTableData = data.data;
                            this.zcjgProps.xh = data.data.length + 1;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 新增年检客户反应表明细
        insertZcjgItem() {
            this.loadZcjgTableData();
            // 设置编辑记录
            this.zcjgProps.dataId = null;
            this.zcjgProps.zcjgbid = this.editData.id;
            //this.zcjgProps.xh = this.$refs.zcjgtable.getTableData().tableData.length + 1;
            // 显示编辑窗口
            this.zcjgProps.showEdit = true;
        },
        editZcjgItem(row) {
            // 设置编辑记录
            this.zcjgProps.dataId = row.id;
            this.zcjgProps.zcjgbid = this.editData.id;
            // 显示新增窗口
            this.zcjgProps.showEdit = true;
        },
        // 删除自查结果反应表明细
        removeZcjgItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.zcjgtable.remove(row);
                    } else {
                        this.zcjgTableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/dwdcgl/dwdc/deleteKhfy", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.zcjgTableDataLoading = false;
                                if (success) {
                                    this.loadZcjgTableData();
                                }
                            });
                    }
                }
            });
        },

        //提交form
        onSave(btnType) {
            // 表单校验
            if (btnType === 1) {
                if (!this.editData.njrq) {
                    this.$FG_message.error("P0001", "调查日期").then(() => this.$refs.njrq.focus());
                    return;
                }
                if (!this.editData.njnf) {
                    this.$FG_message.error("P0001", "调查年份").then(() => this.$refs.njnf.focus());
                    return;
                }
                if (!this.editData.dwlb) {
                    this.$FG_message.error("P0001", "单位类别").then(() => this.$refs.dwlb.focus());
                    return;
                }
                if (!this.editData.zxdj) {
                    this.$FG_message.error("P0001", "资信等级").then(() => this.$refs.zxdj.focus());
                    return;
                }
                if (!this.editData.qymc) {
                    this.$FG_message.error("P0001", "区域名称").then(() => this.$refs.qymc.focus());
                    return;
                }
                if (!this.editData.zcdz) {
                    this.$FG_message.error("P0001", "注册地址").then(() => this.$refs.zcdz.focus());
                    return;
                }
                if (!this.editData.bgdz) {
                    this.$FG_message.error("P0001", "办公地址").then(() => this.$refs.bgdz.focus());
                    return;
                }
                if (!this.editData.yzbm) {
                    this.$FG_message.error("P0001", "邮政编码").then(() => this.$refs.yzbm.focus());
                    return;
                }
                if (!this.editData.hyfl) {
                    this.$FG_message.error("P0001", "行业分类").then(() => this.$refs.hyfl.focus());
                    return;
                }
                if (!this.editData.zczj && this.editData.zczj !== 0) {
                    this.$FG_message.error("P0001", "注册资金（万元）").then(() => this.$refs.zczj.focus());
                    return;
                }
                if (!this.editData.frdb) {
                    this.$FG_message.error("P0001", "法人代表").then(() => this.$refs.frdb.focus());
                    return;
                }
                if (!this.editData.frgddh) {
                    this.$FG_message.error("P0001", "法人固定电话").then(() => this.$refs.frgddh.focus());
                    return;
                }
                if (!this.editData.fryddh) {
                    this.$FG_message.error("P0001", "法人移动电话").then(() => this.$refs.fryddh.focus());
                    return;
                }
                if (!this.editData.lxr) {
                    this.$FG_message.error("P0001", "联系人").then(() => this.$refs.lxr.focus());
                    return;
                }
                if (!this.editData.gddh) {
                    this.$FG_message.error("P0001", "固定电话").then(() => this.$refs.gddh.focus());
                    return;
                }
                if (!this.editData.yddh) {
                    this.$FG_message.error("P0001", "移动电话").then(() => this.$refs.yddh.focus());
                    return;
                }

                if (!this.editData.zgzrs && this.editData.zgzrs !== 0) {
                    this.$FG_message.error("P0001", "职工总人数").then(() => this.$refs.zgzrs.focus());
                    return;
                }
                if (!this.editData.zyjsrs && this.editData.zyjsrs !== 0) {
                    this.$FG_message.error("P0001", "专业技术人员数").then(() => this.$refs.zyjsrs.focus());
                    return;
                }
                if (!this.editData.zzcszxrs && this.editData.zzcszxrs !== 0) {
                    this.$FG_message.error("P0001", "专职从事工程咨询人数").then(() => this.$refs.zzcszxrs.focus());
                    return;
                }
                if (!this.editData.zczxsrs && this.editData.zczxsrs !== 0) {
                    this.$FG_message.error("P0001", "注册咨询师人数").then(() => this.$refs.zczxsrs.focus());
                    return;
                }
                if (!this.editData.gjzcrs && this.editData.gjzcrs !== 0) {
                    this.$FG_message.error("P0001", "高级职称人数").then(() => this.$refs.gjzcrs.focus());
                    return;
                }
                if (!this.editData.zjzcrs && this.editData.zjzcrs !== 0) {
                    this.$FG_message.error("P0001", "中级职称人数").then(() => this.$refs.zjzcrs.focus());
                    return;
                }
                if (!this.editData.cjzcrs && this.editData.cjzcrs !== 0) {
                    this.$FG_message.error("P0001", "初级职称人数").then(() => this.$refs.cjzcrs.focus());
                    return;
                }
                if (!this.editData.bsrs && this.editData.bsrs !== 0) {
                    this.$FG_message.error("P0001", "博士人数").then(() => this.$refs.bsrs.focus());
                    return;
                }
                if (!this.editData.ssrs && this.editData.ssrs !== 0) {
                    this.$FG_message.error("P0001", "硕士人数").then(() => this.$refs.ssrs.focus());
                    return;
                }
                if (!this.editData.bkrs && this.editData.bkrs !== 0) {
                    this.$FG_message.error("P0001", "本科人数").then(() => this.$refs.bkrs.focus());
                    return;
                }
                if (!this.editData.hfjnbz && this.editData.hfjnbz !== 0) {
                    this.$FG_message.error("P0001", "会费缴纳标准（元）").then(() => this.$refs.hfjnbz.focus());
                    return;
                }
                if (!this.editData.bgmj && this.editData.bgmj !== 0) {
                    this.$FG_message.error("P0001", "办公面积(平方)").then(() => this.$refs.bgmj.focus());
                    return;
                }
                if (!this.editData.zymj && this.editData.zymj !== 0) {
                    this.$FG_message.error("P0001", "其中自有面积(平方)").then(() => this.$refs.zymj.focus());
                    return;
                }
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/save",
                    {
                        data: this.editData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        if (btnType === 1) {
                            this.submit();
                        }
                    } else {
                        this.$refs.njnf.focus();
                    }
                });
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/dwdcgl/dwdc/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.njnf.focus();
                            }
                        });
                }
            });
        },

        // 返回列表
        onBack() {
            this.editIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        },
        //加载审核流
        initWorkFlow() {
            this.historyProcessProps.visible = true;
            this.historyProcessProps.billid = this.editData.id;
            this.historyProcessProps.instanceId = this.editData.instanceid;
        }
    }
};
</script>
